// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"430":"7ad9645e","490":"ae842910","591":"648f98e4"}[chunkId] + ".chunk.js";
};